export default "__VITE_PUBLIC_ASSET__ec29c1df__"